import React, { Component, Fragment } from "react";
import { Typography, CircularProgress, Icon, Grid, Button } from "@material-ui/core";
import PropTypes from "prop-types";
import { verificationStatus } from "../../actions/verificationActions";
import LinkHelper from "../Helpers/Link";

export default class Verification extends Component {

    renderStatus( status ) {
        switch ( status ) {
            case verificationStatus.none:
            case verificationStatus.inProgress:
                return (
                    <CircularProgress/>
                );
            case verificationStatus.fail:
                return (
                    <Typography
                        variant="h5"
                        color="error"
                        align="center"
                    >
                        Verification failed
                    </Typography>
                );
            case verificationStatus.success:
                return (
                    <Fragment>
                        <Typography
                            variant="h5"
                            color="primary"
                            align="center"
                        >
                            User verified
                        </Typography>
                        <Icon>
                            check
                        </Icon>
                    </Fragment>
                );
            case verificationStatus.alreadyVerified:
                return (
                    <Typography
                        variant="h5"
                        color="secondary"
                        align="center"
                    >
                        User already verified
                    </Typography>
                );
            default: return;
        }
    }

    componentDidMount() {
        this.props.verify( {uid: this.props.uid, code: this.props.code} );
    }

    render() {
        return (
            <div className="Content-base">
                <Grid container direction="column" justify="flex-start" alignItems="center">
                    {this.renderStatus(this.props.status)}
                    <div style={{height:"2rem"}}/>
                    <LinkHelper to="/login">
                        <Button
                            variant="outlined"
                            color="primary"
                            size="large"
                        >
                            Back to login
                        </Button>
                    </LinkHelper>
                </Grid>
            </div>
        );
    }

}

Verification.propTypes = {
    status: PropTypes.string.isRequired
}